module.exports = __webpack_public_path__ + "static/media/credit-cards_graphic.1d1da457.svg";